import _ from 'lodash'
import { Dispatch } from 'redux'
//******************  ******************//
import { TemplateItems } from "@cmodules/checklist/utility/TemplateItemsConst"
import { ItemVM, Template, TemplateHistoryItemStore, TemplateStore } from "@cmodules/checklist/assets/data/types"
import {
  _convertItemToGlobalItem, addNewMultipleSubTemplateToStore,
  getNestedGlobalTemplateInfoForStorage
} from "@cmodules/checklist/redux/actions/actions"
import { CHECKLIST_STORE_ACTION_TYPES } from "@cmodules/checklist/redux/reducers/actions"
import {
  _deleteAllChildrenAndExcludeItem,
  _getActiveItems,
  CheckRelations,
  generatePreviewData,
  setConflictModal
} from "@cmodules/checklist/utility/templateBuilderContext-new"
import { store } from "@csrc/redux/storeConfig/store"


import { AnyItemVM } from "@cmodules/checklist/assets/data/types/vm/template-builder/item"
import { ServerItemType } from "@cmodules/checklist/assets/data/types/vm/template-builder/server-item-type"
import { SendDropItemToFlutterApp } from '@csrc/utility/FlutterWebMiddleware'
import { _logWithFileContext, uuidv4 } from '@csrc/utility/Utils'
import { _confirm, _getGlobal, trans } from '@src/utility/Utils'
import { _sendEditRequest } from '../redux/actions'

export const _getParentPage = (item: AnyItemVM, items: AnyItemVM[] | null | undefined = null) => {
  const template = _.get(store.getState(), 'checklist.template')
  const tempState = _.get(template, "present")
  const tempItems = items ?? _.get(tempState, 'items')
  let currentItem: AnyItemVM | undefined = item
  while (currentItem && currentItem?.parent_id) {
    currentItem = _.find(tempItems, (_item) => _item.id === currentItem?.parent_id)
  }
  return currentItem
}
//******************  ******************//
export const _getChildren = (item: AnyItemVM, itemsArr: AnyItemVM[] | null | undefined = null) => {
  const template = _.get(store.getState(), 'checklist.template')
  const items = itemsArr ?? template.present.items
  const childrenArr: AnyItemVM[] = []
  items?.slice(_.findIndex(items, x => x.id === item?.id) + 1, items.length)?.every(x => {
    if (childrenArr.find(a => a?.id === x?.parent_id) || item?.id === x?.parent_id) {
      childrenArr.push(x)
      return true
    }
    return false
  })
  return childrenArr
}
//******************  ******************//
export const _checkCollapsedParentsByItem = (item: AnyItemVM, items?: AnyItemVM[]) => {
  const presentItems = items ?? store.getState().checklist.template.present.items
  let parentId = item.parent_id
  let collapsed = false
  while (parentId) {
    const currentItem = _.find(presentItems, (parent) => parent.id === parentId)
    if (!collapsed) {
      collapsed = currentItem?.collapsed ?? false
    }
    parentId = currentItem?.parent_id ?? null
  }
  return collapsed
}
//******************  ******************//
export const _editSubTemplate = (data: TemplateHistoryItemStore, global_item_key: string, callback = () => { }, sendEditRequest = true) => {
  return (dispatch: Dispatch) => {
    if (sendEditRequest) {
      data.need_merge_request = false
      data.options.has_draft = true
    }
    dispatch({ type: CHECKLIST_STORE_ACTION_TYPES.CLK_SUB_TEMPLATE_EDIT, payload: { template: data, global_item_key } })
    // SendDropItemToFlutterApp(data.items)
    callback()
  }
}
//******************  ******************//
export const canConvertToGlobalItem = (selected: AnyItemVM) => {
  let items: AnyItemVM[] = []
  if (selected.type !== 'section') {
    items = [selected]
    const canContinue = CheckRelations(
      {
        items: [selected],
        action: {
          type: 'convert_to_global_item',
          result: undefined,
          activeItems: undefined,
          callback: () => { }
        }
      }
    )
    if (!canContinue) {
      return {
        canContinue: false,
        items
      }
    }
  } else {
    const children = [selected, ..._getChildren(selected)]
    items = children
    const canContinue = CheckRelations(
      {
        items: children,
        action: {
          type: 'convert_to_global_item',
          result: undefined,
          activeItems: undefined,
          callback: () => { }
        }
      }
    )
    if (!canContinue) {
      return {
        canContinue: false,
        items
      }
    }
  }
  return {
    canContinue: true,
    items
  }
}
//******************  ******************//
export const convertItemToGlobal = async (selected: AnyItemVM, template_id: string) => {
  // const canDeleteInfo = canConvertToGlobalItem(selected)
  const templateItemConstant = TemplateItems[selected.type]
  // if (canDeleteInfo.canContinue) {

  if (_.size(selected.title.trim()) === 0) {
    _confirm({
      title: '',
      icon: "error",
      html: trans('checklist.validation.emptyTitleError'),
      showCancelButton: false,
      confirmButtonText: 'Ok'
    })
    return
  }
  _convertItemToGlobalItem(
    { item_id: selected.id, template_id },
    async (data) => {
      const tempState = _.cloneDeep(store.getState().checklist.template.present)
      // let global_template_type =
      let type: ServerItemType

      if (templateItemConstant.type === 'section') {
        tempState.items = _deleteAllChildrenAndExcludeItem(selected?.id, tempState.items)
        type = 'global_section'
      } else if (templateItemConstant.behaviourType === 'page') {
        if (templateItemConstant.type === 'start_page') {
          type = 'global_start_page'
        } else if (templateItemConstant.type === 'end_page') {
          type = 'global_end_page'
        } else {
          type = 'global_page'
        }
        tempState.items = _deleteAllChildrenAndExcludeItem(selected?.id, tempState.items)
      } else {
        type = data.options.template_main_item_type ?? 'global_item'
      }

      const index = _.findIndex(tempState.items, i => i?.id === selected?.id)

      const oldOptions = tempState.items[index]?.options || {}
      const newOptions = {} as Record<string, unknown>
      newOptions['global_item_id'] = data.template_id

      if (oldOptions.rule_set_id) {
        newOptions['rule_set_id'] = oldOptions.rule_set_id
      }
      if (oldOptions.repeatable) {
        newOptions['repeatable'] = oldOptions.repeatable
        newOptions['minimum_repetition'] = oldOptions.minimum_repetition
        newOptions['maximum_repetition'] = oldOptions.maximum_repetition
      }
      if (tempState.items[index].type === 'calculation') {
        const calculationOptions = oldOptions as any
        newOptions['calculations'] = {
          items: calculationOptions?.calculations?.items || []
        }
      }

      if (index > -1 && tempState.items[index]) {
        tempState.items[index] = {
          ...tempState.items[index],
          title: '',
          type,
          global_item_base_id: data.options.template_type === 'item' ? data.options.template_main_item_base_id : null,
          options: newOptions
        } as AnyItemVM
      }

      const selectedGlobalItems = await getNestedGlobalTemplateInfoForStorage(data.template_id, tempState.items[index].id)

      store.dispatch(_editTemplate(tempState, () => { store.dispatch(addNewMultipleSubTemplateToStore(selectedGlobalItems)) }))
    }
  )
  // }
}
//******************  ******************//
export const _editTemplate = (data: TemplateHistoryItemStore, callback = () => { }, sendEditRequest = true) => {
  return (dispatch: Dispatch) => {
    if (sendEditRequest) {
      data.need_merge_request = false
      data.options.has_draft = true
    }
    if (data.options.template_type && data.options.template_main_item_base_id) {
      const main_item = _.find(data.items, x => x.base_id === data.options.template_main_item_base_id)
      if (main_item) {
        const title = main_item.title && _.size(main_item.title.trim()) ? main_item.title : ``
        data.title = title.length > 125 ? `${title.substring(0, 122)}...` : title
        // data.title = main_item.title && _.size(main_item.title.trim()) ? main_item.title : `Global Item Template id:  ${data.template_id}`
        data.options.template_main_item_type = main_item.type
      }
    }
    // const time = moment.now()
    // const templateData = store.getState().checklist.template
    // let relations = {}
    // try {
    //   relations = syncRelations({...templateData, present: data})
    // } catch (e) {
    //   console.error(e)
    // }
    dispatch({ type: "CLK_TEMPLATE_EDIT", payload: { template: data, sendEditRequest } })
    SendDropItemToFlutterApp(data.items)
    if (sendEditRequest) {
      // Convert global_items from object to array format for the shared wrapper function
      const globalItemsRecord = store.getState().checklist.template.global_items || {}
      const globalItemsArray = Object.values(globalItemsRecord).map((g) => g.present)

      // Use the shared wrapper function for consistent transformation
      const finalItemsData = wrapRepeatableItemsForPreview(data.items as AnyItemVM[], globalItemsArray as Template[])


      const template_id = data.template_id
      const tempData = { ...data, template_main_item_type: data.options.template_main_item_type, items: finalItemsData }
      // delete tempData.template_id

      _sendEditRequest(template_id, tempData, (e: unknown) => {
        const error = e as { data?: { error_code?: string; message?: string } }
        if (error?.data?.error_code === 'CKL_REVISION_NOT_MATCH') {
          setConflictModal({ show: true, msg: error.data?.message || '', header: trans('checklist.actions.conflict') })
        } else {
          setConflictModal({ show: true, msg: trans('checklist.actions.unexpectedError'), header: trans('gen.filemanager.Error') })
        }
      })
    }
    callback()
  }
}
//******************  ******************//
export const getLastActiveItemInPage = (pageItem: AnyItemVM) => {
  const activeItems: AnyItemVM[] = _getActiveItems()
  const pageChildren = _getChildren(pageItem, activeItems)
  const lastChild = _.last(pageChildren)
  return lastChild
}
//******************  ******************//
/**
 * Structures template data for preview by merging global item options with local overrides.
 *
 * This function handles the resolution of global templates (nested templates) within a main template.
 * Global templates allow sharing common items across multiple checklists while maintaining the ability
 * to override specific options locally.
 *
 * Merging Strategy:
 * - Global options provide the base configuration (shared across all usages)
 * - Local options override global options (customization per template)
 * - `_.merge` is used: local options take precedence over global options
 *
 * @param currentLevelTemplate - Template containing items and their associated global_items
 * @returns Structured template with merged options ready for preview generation
 */
export const structureDataForPreview = (currentLevelTemplate: Template) => {
  const hasGlobalItems = _.size(currentLevelTemplate.global_items) > 0

  let processedItems = []

  // If no global items, simply clone the same data
  if (!hasGlobalItems) {
    processedItems = _.cloneDeep(currentLevelTemplate.items)
  } else {
    // Process each item and merge global options where applicable
    processedItems = _.map(currentLevelTemplate.items, (item) => {
      const globalItemId = item.options.global_item_id

      // Skip items that are not linked to a global template
      if (!globalItemId) {
        return item
      }

      // Find the global template this item references
      const globalTemplate = _.find(
        currentLevelTemplate.global_items,
        (gItem) => gItem.template_id === globalItemId
      )

      if (!globalTemplate) {
        return item
      }

      // Find the main item within the global template (the primary item that holds shared configuration)
      const globalMainItem = _.find(
        globalTemplate.items,
        (item) => item.base_id === globalTemplate.options.template_main_item_base_id
      )

      // Create a mutable copy for modifications
      let processedItem = { ...item }

      // Merge options: For 'item' type globals, merge global base options with local overrides
      // Local options take precedence (override) over global options
      if (globalTemplate.options.template_type === 'item' && globalMainItem) {
        processedItem = _.merge({}, globalMainItem, item) as typeof item
        processedItem.options = _.merge({}, globalMainItem.options, item.options) as typeof item.options
      }

      // Resolve title: Use global main item title > global template title > local title
      processedItem.title = globalMainItem?.title || globalTemplate.title || item.title

      return processedItem
    })
  }


  // Wrap repeatable items in repeating_group containers for preview
  // This mirrors the same transformation done in _editTemplate when sending to server
  const itemsWithRepeatingGroups = wrapRepeatableItemsForPreview(processedItems as AnyItemVM[], currentLevelTemplate.global_items)

  // Generate the final preview data with processed items
  const items = generatePreviewData({ ...currentLevelTemplate, items: itemsWithRepeatingGroups })

  return {
    ...currentLevelTemplate,
    items
  }
}

/**
 * Wraps repeatable items in repeating_group containers for mobile preview.
 * 
 * This mirrors the same transformation done in _editTemplate when sending data to the server.
 * The mobile app expects repeatable items to be wrapped in a repeating_group container.
 * 
 * Two cases handled:
 * 1. Global items where the global main item has repeatable enabled
 * 2. Local items with repeatable option enabled directly
 * 
 * @param items - Items to process
 * @param globalItems - Global templates lookup for checking repeatable on global items
 * @returns Items with repeatable items wrapped in repeating_group containers
 */
const wrapRepeatableItemsForPreview = (items: AnyItemVM[], globalItems: Template[] = []): AnyItemVM[] => {
  const finalItems: AnyItemVM[] = []
  // _logWithFileContext(`Wrapping repeatable items for preview. Total items: ${items.length}, Global templates: ${globalItems.length}`, 'template-builder-utilities.ts')

  _.forEach(items, (item) => {
    // Case 1: Global item with repeatable main item
    if (item.global_item_base_id) {
      const globalTemplate = _.find(globalItems, (g) => _.some(g.items, (i) => i.base_id === item.global_item_base_id))
      if (globalTemplate) {
        const globalMainItem = _.find(globalTemplate.items, (i) => i.base_id === item.global_item_base_id)
        if (globalMainItem?.options?.repeatable) {
          const repeatingGroupWrapper = createRepeatingGroupWrapper(item)
          finalItems.push(repeatingGroupWrapper)
          const wrappedItem = _.cloneDeep(item)
          wrappedItem.parent_id = repeatingGroupWrapper.id
          finalItems.push(wrappedItem)
          return // Skip the else block below
        }
      }
    }

    // Case 2: Local item with repeatable enabled
    if (item.options?.repeatable) {
      const repeatingGroupWrapper = createRepeatingGroupWrapper(item)
      finalItems.push(repeatingGroupWrapper)
      const wrappedItem = _.cloneDeep(item)
      wrappedItem.parent_id = repeatingGroupWrapper.id
      finalItems.push(wrappedItem)
    } else {
      finalItems.push(item)
    }
  })

  return finalItems
}

/**
 * Creates a repeating_group wrapper item for a repeatable item.
 */
const createRepeatingGroupWrapper = (item: AnyItemVM): AnyItemVM => {
  const wrapper = new ItemVM<'repeating_group'>({
    id: uuidv4(),
    base_id: '',
    parent_id: item.parent_id,
    type: 'repeating_group',
    title: item.title,
    collapsed: false
  })
  wrapper.options.repeatable = true
  wrapper.options.minimum_repetition = item.options?.minimum_repetition
  wrapper.options.maximum_repetition = item.options?.maximum_repetition
  return wrapper
}
//******************  ******************//
export const isSingleTemplateFirstRevision = (data?: Partial<TemplateStore>) => {
  const revision = _getGlobal('ckl_revision') ?? (data ?? store.getState().checklist.template)?.present?.revision
  const checkCondition = (data ?? store.getState().checklist.template)?.present?.options?.template_type === 'item' && !(data ?? store.getState().checklist.template)?.present?.options.published && revision?.startsWith('1-')
  return !!checkCondition
}